import { OptionInterface } from '@app/models/util';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

export const Tabs = ({
  tabs,
  onClick,
  defaultValue,
}: {
  tabs: OptionInterface[];
  onClick?: (value: string) => void;
  defaultValue?: string;
}) => {
  const [activeTab, setActiveTab] = useState(defaultValue ?? tabs?.[0]?.value);

  useEffect(() => {
    if (defaultValue) {
      setActiveTab(defaultValue);
    }
  }, [defaultValue]);

  return (
    <div className="overflow-y-auto">
      <ul className="flex gap-2">
        {tabs.map((tab) => (
          <li
            key={tab.value}
            onClick={() => {
              setActiveTab(tab.value);
              onClick && onClick(tab.value);
            }}
            className={clsx(
              'text-base-coolGray text-sm py-2 px-4 cursor-pointer flex items-center gap-1 relative',
              {
                'text-base-raisinBlack font-bold': activeTab === tab.value,
                'font-medium': activeTab !== tab.value,
              }
            )}
          >
            <span>{tab.label}</span>
            {tab.count !== undefined && (
              <span className="text-base-davyGray text-xs bg-base-antiFlash h-5 flex items-center px-2 w-fit rounded-[4px]">
                {tab.count}
              </span>
            )}
            {/* Dark horizontal line for selected tab */}
            {activeTab === tab.value && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-base-raisinBlack"></div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
